module.exports = ":host {\n  user-select: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/calendar/calendar/calendar.component.less
// module id = 1471
// module chunks = 1